import { render, staticRenderFns } from "./ModalCreateCategoryBill.vue?vue&type=template&id=2e2cd52c&scoped=true"
import script from "./ModalCreateCategoryBill.vue?vue&type=script&lang=js"
export * from "./ModalCreateCategoryBill.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateCategoryBill.vue?vue&type=style&index=0&id=2e2cd52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cd52c",
  null
  
)

export default component.exports